import React from 'react';
import { useSeasonTheme } from 'context/SeasonThemeContext';
import SnowEffect from './SnowEffect';
import HalloweenEffect from './HalloweenEffect';

const SeasonalEffects = () => {
    const { seasonTheme, isLoading } = useSeasonTheme();

    if (isLoading) return null;

    return (
        <>
            <SnowEffect />
            <HalloweenEffect />
        </>
    );
};

export default SeasonalEffects;
